<template>
    <div>
        <DCard
            padding
        >
            <p class="mt-1">
                {{ __('tools.testing.tenant.delete_description') }}
            </p>
            <DFormRow
                :label="__('tools.testing.tenant.form.tenant')"
                is-vertical
            >
                <select
                    id="tenant"
                    v-model="tenant"
                    class="form-control w-50"
                >
                    <option
                        value=""
                        selected
                        hidden
                    >
                        {{ __('tools.testing.tenant.form.select_tenant') }}
                    </option>
                    <option
                        v-for="(tenantName, key) in tenantNames"
                        :key="key"
                        :value="tenantName"
                    >
                        {{ tenantName }}
                    </option>
                </select>
                <DButton
                    id="btn-save"
                    :label="__('tools.testing.tenant.form.delete')"
                    :mini="true"
                    color="primary"
                    class="mt-3"
                    :disabled="isInLoadingState"
                    @click="deleteTenant"
                />
            </DFormRow>
        </DCard>
        <DModal
            v-model:show="showConfirmationModal"
            :title="__('tools.testing.tenant.delete_confirmation.title')"
            :message="__('tools.testing.tenant.delete_confirmation.message')"
            is-confirm
            is-error
            @close="showConfirmationModal = false"
            @confirm="deleteCallBack"
        />
    </div>
</template>

<script>
export default {
    name: 'TenantsDelete',
    props: {
        tenantNames: {
            type: Array,
            default: () => { return [] }
        }
    },
    data () {
        return {
            tenant: null,
            showConfirmationModal: false,
            deleteCallBack: () => {}
        }
    },
    methods: {
        deleteTenant () {
            this.deleteCallBack = () => {
                this.$inertia.delete(this.$route('tools.tenant.destroy', {
                    tenant: this.tenant
                }))
            }
            this.showConfirmationModal = true
        }
    }
}
</script>
